export default __webpack_public_path__ + "static/media/step2.6d7ed9cf.png";